<app-uni-page [parent]="this" pageTitle="References: Phaseout Drain" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>
<ng-template #bodyTemplate>
  <div *ngIf="isPageReady" class="flex flex-col h-full">
    <div class="qb-list-actions">
      <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-refresh" (click)="refresh()">
        <span>Refresh</span>
      </button>
      <button
        *ngIf="user.isProductAdmin"
        pButton
        type="button"
        class="p-button-raised p-button-sm ml-2"
        icon="pi pi-ban"
        [disabled]="pickedCount === 0"
        (click)="confirmInactiveSelected()"
      >
        <span>Confirm Inactive on Selected</span>
      </button>
      <span class="ml-4 self-center">
        {{ list.Rows.length }} on Phaseout. {{ drainedCount }} have no open work.
        <span *ngIf="!user.isProductAdmin">Only a product admin can make them Inactive.</span>
      </span>
    </div>
    <div *ngIf="!list.ProximityChecked" class="mb-2 text-red-500">
      The system cannot check Proximity. Rows with no open work in Uniformax show "Cannot check Proximity". Refresh the list later.
    </div>
    <app-ag-grid [gridOptions]="gridOptions" [rowData]="list.Rows" class="flex-1 min-h-0"></app-ag-grid>
  </div>
</ng-template>
<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
